import httpClient from '../lib/httpClient';

export interface StateCount {
  state: string;
  count: number;
}

export interface TenantStateCounts {
  tenant: string;
  counts: StateCount[];
}

export interface TenantPlatformStateCounts {
  tenant: string;
  platform: string;
  counts: StateCount[];
}

export interface TenantStateCountsResponse {
  total: StateCount[];
  tenantBreakdown: TenantStateCounts[];
  // Additive field; absent until the gateway ships the per-platform analytics rollup.
  // Note: a show published on one platform and unpublished on another appears in
  // both state buckets — per-platform buckets are not disjoint within a tenant.
  tenantPlatformBreakdown?: TenantPlatformStateCounts[];
}

export const analyticsService = {
  async getTenantStateCounts(): Promise<TenantStateCountsResponse> {
    return httpClient.get('/api/v1/reels-cms/analytics/tenant-state-counts');
  },
};
